<template>
  <ImageUploadField
    v-bind="props"
    v-model="context.value.value[props.field.key]"
  />
</template>

<script setup lang="ts">
import { useFormKitContext } from '@formkit/vue'

import ImageUploadField from '../ImageUploadField.vue'
import type { SchemaFormKitProps } from './types'

const props = defineProps<SchemaFormKitProps>()
const context = useFormKitContext()
</script>
